<template>
    <CustomSelectOne v-if="!loading" :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
                     item-label="label" :item-value="itemValue" :label="label" :required="required"
                     :noPlaceholder="noPlaceholder"/>
</template>

<script>
import CustomSelectOne from "./inner/CustomSelectOne";
import {getCoveringResultTypesEnum} from "@/swagger/vue-api-client";

export default {
    name: "CustomSelectOneResultType",
    components: {CustomSelectOne},

    props: {
        name: {
            type: String,
        },
        label: {
            type: String,
        },
        emptyValue: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        modelValue: null,
        noPlaceholder: {
            type: Boolean,
            default: false,
        },
        itemValue: {
            type: String,
            default: "value",
        },
    },

    emits: ["update:modelValue"],

    computed: {
        internalValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },

    data() {
        return {
            loading: false,
            items: [],
        };
    },

    beforeMount() {
        this.loading = true;
        getCoveringResultTypesEnum().then((response) => {
            this.items = response.data;
            this.loading = false;
        });
    },
};
</script>

<style scoped>
</style>
